<!--
  triggered by
  <a class="nav-link py-2 px-2 {{ $attributes->get('nav-link-class') }}" href="#" data-bs-toggle="modal" data-bs-target="#searchModal"><i class="bi bi-search fs-5"></i> <span class="d-lg-none ps-1">Αναζήτηση</span></a>
-->
<template>
  <div class="modal fade" id="searchModal" tabindex="-1" aria-labelledby="searchModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-fullscreen">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title" id="searchModalLabel">{{ title }}</h2>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row justify-content-center">
            <div class="col-auto w-50">
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-magnifying-glass"></i></span>
                <input @keyup="keyMonitor" v-model="term" type="search" class="form-control form-control-lg" id="globalSearchInput" :placeholder="$placeholder">
                <button :disabled="!allowSearch" @click="search" type="button" class="btn btn-primary btn-lg">{{ button }}</button>
              </div>
            </div>
          </div>
          <div class="row justify-content-center mt-3">
            <div class="col-auto">
                <p v-if="!allowSearch"><small>{{ min_chars }}</small></p>
            </div>
          </div>
          <div class="row justify-content-center mt-5">
            <div class="col-auto w-50">
              <div v-for="category in results" class="col-auto mb-4">
                <h3><i :class="['fa-regular fa-fw', category.icon.key]"></i> {{ category.heading }}</h3>
                <ul class="list-group">
                  <li v-for="item in category.results" class="list-group-item list-group-item-action py-3"><a :href="item.url" class="stretched-link"><i class="fa-sharp fa-solid fa-circle-arrow-right pe-2"></i> {{ item.title }}</a></li>
                </ul>
                <p v-if="!category.results.length">{{ no_results }}</p>
              </div>
              <p v-if="results.length === 0 && allowSearch && termModified === false">{{ no_results }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      allowSearch: false,
      results: [],
      term: '',
      termModified: false,
    };
  },
  computed: {
    charCount() {
      return this.term.length;
    },
  },
  methods: {
    search: function(event) {
      this.termModified = false;
      this.results = [];
      axios.post("/search", {
          term: this.term
      })
      .then((response) => {
        this.results = response.data;
      });
    },
    keyMonitor: function(event) {
      this.termModified = true;

      if (this.charCount > 3) {
        this.allowSearch = true;
      } else if (this.charCount <= 3) {
        this.allowSearch = false;
      }

      if (event.key === "Enter" && this.allowSearch) {
        this.search();
      }
    }
  },
  props: [
    'title',
    'button',
    'min_chars',
    'no_results'
  ],
}
</script>
